/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Fade } from 'react-reveal';
import { Col, Container, Row } from 'reactstrap';
import build from '../assets/lottie/build.json';
import GreetingLottie from '../components/DisplayLottie';
import ExperienceCard from '../components/ExperienceCard';
import { presentWork } from '../portfolio';

function PresentWork() {
  return (
    <section className="section section-lg pb-0 bg-gradient-primary my-5">
      <Container>
        <Fade left duration={1000} distance="40px">
          <Row className="row-grid align-items-center">
            <Col lg={6}>
              <div className="d-flex p-4">
                <div>
                  <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
                    <i className="ni ni-briefcase-24 text-info" />
                  </div>
                </div>
                <div className="pl-4">
                  <h4 className="display-3 text-white">Present Work Status</h4>
                </div>
              </div>
              {presentWork.map((data, index) => (
                <ExperienceCard key={index} data={data} headerColor="#00379b" />
              ))}
            </Col>
            <Col lg={6}>
              <GreetingLottie animationData={build} />
            </Col>
          </Row>
        </Fade>
      </Container>
      <div className="separator separator-bottom separator-skew zindex-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon className="fill-white" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </section>
  );
}

export default PresentWork;
